import React from "react";
import ReactDOM from "react-dom";
import { IntlProvider } from "react-intl";
import App from "./app";

// polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";
import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/dist/locale-data/en"; // locale-data for en
import "@formatjs/intl-unified-numberformat/polyfill";

if (typeof Intl.NumberFormat.__addLocaleData === "function") {
  Intl.NumberFormat.__addLocaleData(
    require("@formatjs/intl-unified-numberformat/dist/locale-data/en.json") // locale-data for en
  );
}

ReactDOM.render(
  <IntlProvider locale="en-US">
    <App />
  </IntlProvider>,
  document.getElementById("root")
);
